<template>
    <div class="main-content">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>线下培训任务</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" size="small" :model="formInline" class="user-search">
            <el-form-item label="科目类别：">
                <el-select clearable v-model="formInline.courseCategoryId">
                    <el-option v-for="item in courseList" :key="item.courseCategoryId" :label="item.courseCategoryName"
                        :value="item.courseCategoryId"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="任务名称：">
                <el-input size="small" v-model="formInline.planName" placeholder="请输入任务名称"></el-input>
            </el-form-item>
            <el-form-item label="计划人：">
                <el-input size="small" v-model="formInline.plannerUserName" placeholder="请输入计划人"></el-input>
            </el-form-item>
            <el-form-item label="年度：">
                <el-select clearable v-model="formInline.year">
                    <el-option v-for="item in yearList" :key="item.id" :label="item.label" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属部门">
                <el-cascader :options="deptTreeList" v-model="formInline.plannerDeptId" clearable filterable
                    :show-all-levels="false" :props="{
                        label: 'deptName', value: 'deptId',
                        checkStrictly: true,
                        emitPath: false,
                    }"></el-cascader>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" @click="search()">搜索</el-button>
                <el-button v-buttonAuth="'system:offlineTrainingList:add'" size="small" type="primary"
                    @click="handleEdit()">新建</el-button>
                <el-button v-buttonAuth="'system:offlineTrainingList:export'" @click="exportExcel()" size="small"
                    type="primary">导出</el-button>
            </el-form-item>
        </el-form>
        <div class="main-table">
            <my-table :columns="tableForm.customColumns" :tableData="tableForm.tableData"
                :loading="tableForm.isLoading">
                <el-table-column prop="userSex" width="200px" label="操作">
                    <template slot-scope="scope">
                        <div class="d-flex fz14 col-29f cs-pit">
                            <el-button type="text" v-if="!scope.row.publishSign"
                                v-buttonAuth="'system:offlineTrainingList:edit'" class="col-29f operate"
                                @click="handleEdit(null, scope.row)">编辑</el-button>

                            <el-popconfirm title="是否发布数据？" :ref="`release-${scope.row.offlineTrainPlanId}`"
                                @confirm="handleAction(5, scope.row)">
                                <el-button slot="reference" type="text" v-show="!scope.row.publishSign"
                                    v-buttonAuth="'system:offlineTrainingList:release'"
                                    class="col-29f operate">发布</el-button>
                            </el-popconfirm>


                            <el-button type="text" v-buttonAuth="'system:offlineTrainingList:details'"
                                class="col-0f0 operate" @click="handleEdit(2, scope.row)">详情</el-button>

                            <el-button type="text" v-buttonAuth="'system:offlineTrainingList:upload'"
                                class="col-29f operate" v-if="!scope.row.trainResult && scope.row.publishSign"
                                @click="handleAction(6, scope.row)">
                                上传培训记录表</el-button>

                            <el-button type="text" v-buttonAuth="'system:offlineTrainingList:show'"
                                v-if="scope.row.trainResult" class="col-29f operate"
                                @click="handleAction(7, scope.row)">查看培训记录表</el-button>

                            <el-popconfirm title="是否删除数据？" :ref="`delete-${scope.row.offlineTrainPlanId}`"
                                @confirm="handleAction(4, scope.row)">
                                <el-button slot="reference" type="text" v-show="!scope.row.publishSign"
                                    v-buttonAuth="'system:offlineTrainingList:delete'"
                                    class="col-f41 operate">删除</el-button>
                            </el-popconfirm>
                        </div>
                    </template>
                </el-table-column>
            </my-table>
        </div>
        <div class="main-pagination">
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div>
        <el-dialog :title="title" :visible.sync="editFormVisible" :close-on-click-modal="false"
            custom-class="form-dialog" width="70%">
            <my-form :form-config="formConfig.formItems" ref="editForm" :disable-form="formConfig.disabled"
                :formRules="formConfig.formRules" :dataForm="formConfig.dataForm">

                <template #file>
                    <el-table v-if="title == '查看'" :data="formConfig.dataForm.annexes" border style="width: 100%">
                        <el-table-column prop="name" label="文件名称"></el-table-column>
                        <el-table-column label="操作" width="180">
                            <template slot-scope="scope">
                                <span class="col-29f cs-pit"
                                    @click="fileDownload(URL + scope.row.fileKey, scope.row.name)">下载</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <my-upload v-else v-bind="property" :fileList="formConfig.dataForm.annexes"
                        @upload-remove="handleRemove" @uploadChange="handleChange">
                        <div slot="tip">
                            <span style="color:red;">注：支持文件格式pdf</span>
                        </div>
                    </my-upload>
                </template>
                <template #userIds>
                    <div>已选择：{{ dialogSelectData.beforeType == formConfig.dataForm.traineeType ?
                        formConfig.selectTraineeLabel : '-'
                        }}
                    </div>
                    <el-button type="primary" @click="showSelectDialog()">添加培训{{ formConfig.dataForm.traineeType ===
                        'dept'
                        ? '部门' :
                        '人员' }}</el-button>
                </template>
                <template #deptIds>
                    <div>已选择：{{ dialogSelectData.beforeType == formConfig.dataForm.traineeType ?
                        formConfig.selectTraineeLabel : '-'
                        }}
                    </div>
                    <el-button type="primary" @click="showSelectDialog()">添加培训{{ formConfig.dataForm.traineeType ===
                        'dept'
                        ? '部门' :
                        '人员' }}</el-button>
                </template>
            </my-form>
            <div slot="footer" class="dialog-footer" v-if="!formConfig.disabled">
                <el-button size="small" @click='closeDialog()'>取消</el-button>
                <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">保存</el-button>
            </div>
        </el-dialog>
        <!-- //上传培训记录表 -->
        <el-dialog :title="trainingRecordSheet.title" :close-on-click-modal="false"
            :visible.sync="trainingRecordSheet.visible" width="50%">

            <template v-if="trainingRecordSheet.title === '上传培训记录表'">
                <my-upload :fileList="trainingRecordSheet.materialFileList" v-bind="property1"
                    @upload-remove="uploadRemove1" @upload-success="uploadSuccess" @beforeUpload="beforeUpload1">
                    <template #upload-button>
                        <el-button size="small" type="primary">点击上传</el-button>
                    </template>

                    <template #tip>
                        <div v-html="'注：仅支持png、jpeg、jpg、pdf格式上传'"></div>
                    </template>
                </my-upload>
            </template>

            <template v-else>
                <el-table :data="trainingRecordSheet.materialFileList" :show-header="false" style="width: 100%">
                    <el-table-column prop="name" label="文件名称">
                    </el-table-column>
                    <el-table-column width="180">
                        <template slot-scope="scope">
                            <el-button size="mini"
                                @click="fileDialog.fileUrl = URL + scope.row.fileKey; fileDialog.suffix = scope.row.suffix; fileDialog.visible = true">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <div slot="footer" class="dialog-footer text-rgt">
                <div v-if="trainingRecordSheet.title === '上传培训记录表'">
                    <el-button size="small" @click='trainingRecordSheet.visible = false'>取消</el-button>
                    <el-button size="small" type="primary" :loading="trainingRecordSheet.loading"
                        @click="submitFile()">确定</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="查看培训记录表" :close-on-click-modal="false" :visible.sync="fileDialog.visible" width="50%">

            <template v-if="fileDialog.suffix === 'pdf' || fileDialog.suffix === 'PDF'">
                <div v-loading="fileDialog.fileLoading" element-loading-text="资源较大，拼命加载中..."
                    element-loading-background="rgba(0, 0, 0, 0.8)" class="file-right">
                    <vuePdf :src="fileDialog.fileUrl" :page="fileDialog.pageCount" @progress="pdfLoad($event)"
                        @num-pages="fileDialog.pageAllCount = $event" />
                </div>
                <div class="d-flex flex-justify-end flex-align-center">
                    <el-button type="primary" :disabled="fileDialog.pageCount === 1"
                        @click="fileDialog.pageCount--">上一页</el-button>
                    <div class="fz24"> {{ fileDialog.pageCount }} / {{ fileDialog.pageAllCount }} </div>
                    <el-button type="primary" :disabled="fileDialog.pageCount === fileDialog.pageAllCount"
                        @click="fileDialog.pageCount++">下一页</el-button>
                </div>
            </template>
            <div v-else>
                <img :src="fileDialog.fileUrl" alt="" v-loading="fileDialog.fileLoading" style="max-width: 100%;" />

            </div>
        </el-dialog>
        <!-- 全选内容 -->
        <myTransfer :traineeType="formConfig.dataForm.traineeType" :dialogSelectData="dialogSelectData"
            @confirmSelect="confirmSelect" @cancel="dialogSelectData.visible = false;">
        </myTransfer>
        <!--     
        <el-dialog title="选择" :visible.sync="dialogSelectData.visible" :close-on-click-modal="false" width="50%">
            <el-transfer v-model="dialogSelectData.selectVal" :titles="[`未选${formConfig.dataForm.traineeType ===
                'dept'
                ? '部门' : '人员'}`, `已选${formConfig.dataForm.traineeType ===
                    'dept'
                    ? '部门' : '人员'}`]" filterable :data="dialogSelectData.data"></el-transfer>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogSelectData.visible = false">取 消</el-button>
                <el-button type="primary" @click="confirmSelect()">确 定</el-button>
            </span>
        </el-dialog> -->
    </div>
</template>

<script>
import courseApi from '@/api/onlineTraining/classification.js'
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
import myUpload from '@/components/myUpload.vue';
import myForm from '@/components/myForm.vue';
import { organizationName, fileDownload, downloadFile } from "@/utils/util.js";
import { deptTree, deptList } from '@/api/dept.js'
import { section, calculateHash, uploadChunks } from '@/utils/fileSection';
import { archiveList } from '@/api/employee';
import vuePdf from 'vue-pdf';
import { offlinePage, offlineEdit, offlineAdd, offlineExport, offlinePublish, offlinePublishStatus, offlineDetails, offlineRemove, offlineResultUpload } from '@/api/offline.js'
import { taskTypeList } from '@/api/taskType';
import myTransfer from '@/components/myTransfer';

export default {
    components: {
        MyTable,
        Pagination,
        myUpload,
        myForm,
        vuePdf,
        myTransfer
    },
    data () {
        return {
            courseList: [],
            yearList: [],
            formInline: {
                courseCategoryId: '',
                planName: '',
                plannerUserName: '',
                year: '',
                plannerDeptId: ''
            },
            deptTreeList: [],

            tableForm: {
                customColumns: [
                    { label: '所属机构', prop: 'name', formatter: () => { return organizationName } },
                    { label: '编码', prop: 'planCode' },
                    { label: '任务名称', prop: 'planName' },
                    { label: '年度', prop: 'year' },
                    { label: '月份', prop: 'month' },
                    { label: '科目类别', prop: 'courseCategoryName' },
                    { label: '制定日期', prop: 'formulateDate' },
                    { label: '预计实施日期', prop: 'expectedImplementationDate' },
                    { label: '计划人', prop: 'plannerUserName' },
                    { label: '计划人所属部门', prop: 'plannerDeptName' },
                    { label: '责任人', prop: 'dutyName' },
                    { label: '责任人所属部门', prop: 'dutyDeptName' },
                    { label: '要求完成时间', prop: 'requiredCompletionDate' },
                    { label: '发布时间', prop: 'publishTime' },
                ],
                tableData: [
                ],
                isLoading: false,
            },
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            editFormVisible: false, //控制编辑页面显示与隐藏
            title: '新建',
            property: {
                config: {
                    customAction: "/api/file/upload", // 替换成你的上传地址
                    accept: '.pdf',
                    showFileList: true,
                    headers: {
                    },
                    autoUpload: false,
                    disabled: false,
                    limit: 5,
                    uploadData: {
                        // 可选的上传数据
                    },
                    yourValue: [], // 双向绑定的值
                },
            },
            property1: {
                config: {
                    customAction: "/api/file/upload", // 替换成你的上传地址
                    accept: '.png,.jpg,.jpeg,.pdf',
                    showFileList: true,
                    headers: {
                    },
                    disabled: false,
                    limit: 10,
                    uploadData: {
                        // 可选的上传数据
                    },
                    yourValue: [], // 双向绑定的值
                },
            },
            // 编辑与添加
            formConfig: {
                formItems: [
                    { type: 'input', prop: 'planName', label: '任务名称:', span: 12 },
                    { type: 'select', prop: 'courseCategoryId', label: '科目类别:', options: [], span: 12 },
                    { type: 'select', prop: 'year', label: '年度:', options: [], span: 12 },
                    { type: 'select', prop: 'month', label: '月份:', options: [], span: 12 },
                    {
                        type: 'select', prop: 'taskTypeId', label: '任务分类:', options: [
                        ], span: 12
                    },
                    {
                        type: 'cascader',
                        prop: 'hostDeptId',
                        label: '主办部门',
                        options: [],
                        span: 12,
                        property: {
                            clearable: true,
                            filterable: true,
                            'show-all-levels': false,
                            props: { label: 'deptName', value: 'deptId', checkStrictly: true, emitPath: false }
                        }
                    },
                    { type: 'date', prop: 'formulateDate', label: '制定日期:', span: 12 },
                    { type: 'date', prop: 'expectedImplementationDate', label: '预计实施日期:', span: 12 },
                    { type: 'textarea', prop: 'planContent', label: '任务内容:', options: [], maxlength: 300, span: 12 },
                    { type: 'select', prop: 'plannerUserId', label: '计划人:', options: [], span: 12 },
                    { type: 'input', prop: 'plannerDeptName', label: '计划人部门:', span: 12, disable: true },
                    {
                        prop: 'file', slot: 'upload', label: '附件:', span: 24,
                    },
                    { type: 'select', prop: 'dutyId', label: '责任人:', options: [], span: 12 },
                    { type: 'input', prop: 'dutyDeptName', label: '责任人部门:', span: 12, disable: true },
                    { type: 'date', prop: 'requiredCompletionDate', label: '要求完成日期:', span: 12 },
                    {
                        type: 'number', prop: 'classHour', label: '学时:', span: 12, property: {
                            step: 0.1,
                            precision: 1
                        }
                    },
                    {
                        type: 'radio', prop: 'traineeType', label: '培训人员:', options: [
                            {
                                label: '指定部门培训',
                                id: 'dept'
                            },
                            {
                                label: '指定人员培训',
                                id: 'user'
                            }

                        ]
                    },
                    {
                        prop: 'userIds', label: '', options: [],
                        property: {
                            multiple: true
                        }
                    },
                    {
                        prop: 'deptIds', label: '', hide: true, options: [],
                        property: {
                            clearable: true,
                            filterable: true,
                            'show-all-levels': false,
                            props: {
                                label: 'deptName', value: 'deptId', checkStrictly: true, emitPath: false,
                                multiple: true
                            }
                        },
                    },
                    {
                        type: 'radio', prop: 'noticeSign', label: '通知学员:', options: [
                            {
                                label: '通知',
                                id: true
                            },
                            {
                                label: '不通知',
                                id: false
                            }

                        ]
                    },
                ],
                formRules: {
                    planName: { required: true, message: '请输入计划名称', trigger: 'blur' },
                    courseCategoryId: { required: true, message: '请选择科目类别', trigger: 'change' },
                    year: { required: true, message: '请选择年度', trigger: 'change' },
                    month: { required: true, message: '请选择月份', trigger: 'change' },
                    taskTypeId: { required: true, message: '请选择任务分类', trigger: 'change' },
                    hostDeptId: { required: true, message: '请选择主办部门', trigger: 'change' },
                    expectedImplementationDate: { required: true, message: '请选择预计实施日期', trigger: 'change' },
                    plannerUserId: { required: true, message: '请选择计划人', trigger: 'change' },
                    dutyId: { required: true, message: '请选择责任人', trigger: 'change' },
                    classHour: { required: true, message: '请输入学时', trigger: 'blur' },
                    userIds: { required: true, message: '请选择培训人员', trigger: 'change' },
                    deptIds: { required: true, message: '请选择培训人员', trigger: 'change' },
                    noticeSign: { required: true, message: '请选择是否通知学员', trigger: 'change' },
                    traineeType: { required: true, message: '请选择', trigger: 'change' },

                },
                selectTraineeLabel: '',
                dataForm: {
                    traineeType: 'user',
                    annexes: [],
                    noticeSign: true,
                }
            },
            URL: envConfig.NODE_IMG_API,
            trainingRecordSheet: {
                loading: false,
                visible: false,
                title: '上传',
                materialFileList: [],
                fileList: [
                    {
                        a: 1,
                    }
                ],
            },
            fileDialog: {
                fileLoading: false,
                visible: false,
                fileUrl: '',
                pdfUrl: null,
                pageCount: 1,
                suffix: '',
                pageAllCount: 0,
            },
            offlineTrainPlanId: '',
            dialogSelectData: {
                visible: false,
                data: [],
                beforeType: '',
                selectVal: []

            },
            commonAllDept: []
        }
    },
    watch: {
        'formConfig.dataForm.traineeType' (i, j) {
            this.changeExamType()
        },
        'formConfig.dataForm.dutyId' (i, j) {
            if (i) {

                this.formConfig.dataForm.dutyDeptName = this.formConfig.formItems[9].options.find(item => item.id == i).deptName
                this.formConfig.dataForm.dutyDeptId = this.formConfig.formItems[9].options.find(item => item.id == i).deptId
            }


        },
        'formConfig.dataForm.plannerUserId' (i, j) {
            if (i) {
                this.formConfig.dataForm.plannerDeptName = this.formConfig.formItems[9].options.find(item => item.id == i).deptName
                this.formConfig.dataForm.plannerDeptId = this.formConfig.formItems[9].options.find(item => item.id == i).deptId

            }

        }
    },
    created () {
        this.getDictionary();
        this.getDeptTree();
        this.getData();
    },
    methods: {
        fileDownload,
        callFather (parm) {
            this.pageparm.currentPage = parm.currentPage
            this.pageparm.pageSize = parm.pageSize
            this.getData();
        },
        search () {
            this.pageparm.currentPage = 1;
            this.getData();
        },
        async getData () {
            const params = {
                pageNum: this.pageparm.currentPage,
                pageSize: this.pageparm.pageSize,
                ...this.formInline,
            }
            const res = await offlinePage(params);
            this.tableForm.tableData = res.data.records;
            this.pageparm.total = res.data.total;
            this.$forceUpdate()
        },
        async getDictionary () {
            const taskTypeRes = await taskTypeList({ stateSign: true });
            this.formConfig.formItems[4].options = taskTypeRes.data.map(item => {
                return { ...item, label: item.taskTypeText, id: item.taskTypeId };
            });

            const year = new Date().getFullYear();
            this.yearList = [];
            for (let i = year - 5; i <= year + 5; i++) {
                this.yearList.push({ label: i, id: i.toString() });
            }
            this.formConfig.formItems[2].options = this.yearList;
            this.formConfig.formItems[3].options = [
                {
                    label: '1月',
                    id: 1,
                },
                {
                    label: '2月',
                    id: 2,
                },
                {
                    label: '3月',
                    id: 3,
                },
                {
                    label: '4月',
                    id: 4,
                },
                {
                    label: '5月',
                    id: 5,
                },
                {
                    label: '6月',
                    id: 6,
                },
                {
                    label: '7月',
                    id: 7,
                },
                {
                    label: '8月',
                    id: 8,
                },
                {
                    label: '9月',
                    id: 9,
                },
                {
                    label: '10月',
                    id: 10,
                },
                {
                    label: '11月',
                    id: 11,
                },
                {
                    label: '12月',
                    id: 12,
                },
            ];
            const courseRes = (await courseApi.courseCategoryList({ pageNum: 1, pageSize: 999999, stateSign: true })).data;
            this.formConfig.formItems[1].options = courseRes.map(el => {
                return {
                    ...el,
                    id: el.courseCategoryId,
                    label: el.courseCategoryName
                }
            });
            this.courseList = courseRes;
        },
        async handleChange (data, fileList) {
            this.$store.state.loading = true;
            if (!data.name.toLowerCase().includes('pdf')) {
                this.$store.state.loading = false;
                this.$message({ message: '请上传正确的格式！', type: 'error' })
                this.formConfig.dataForm.annexes = [];
                return false;
            }
            const blobArr = section(data, 10);
            const hash = await calculateHash(blobArr, 10);
            const res = await uploadChunks(blobArr, hash, data.name);
            if (res === false) {
                this.$message({ message: '文件上传失败，请重新上传', type: 'warning' })
                this.formConfig.dataForm.annexes = [];
            } else {
                if (res.data.allCompleted) {
                    this.formConfig.dataForm.annexes.push({
                        url: res.data.fileKey,
                        fileKey: res.data.fileKey,
                        name: data.name,
                        size: data.size,
                        suffix: data.name.split('.')[data.name.split('.').length - 1]
                    });
                    this.$store.state.loading = false;
                }
            }
        },
        //  删除
        handleRemove (fileData, fileList) {
            const index = this.formConfig.dataForm.annexes.findIndex(res => res.uid === fileData.uid || res.fileKey === fileData.fileKey);
            this.formConfig.dataForm.annexes.splice(index, 1);
        },
        async getDeptTree () {
            const res = await deptTree();
            this.commonDept = res.data
            const archiveRes = await archiveList({});
            this.commonUser = archiveRes.data.map(item => {
                return { ...item, label: item.userName, id: item.archiveId };
            });
            const allDept = await deptList({
                "pageNum": 1,
                "pageSize": 9999
            })
            this.deptTreeList = res.data;

            this.commonAllDept = allDept.data;
            this.formConfig.formItems[18].options = this.commonDept;
            this.formConfig.formItems[5].options = this.commonDept;
            this.formConfig.formItems[17].options = this.commonUser;
            this.formConfig.formItems[9].options = this.commonUser;
            this.formConfig.formItems[12].options = this.commonUser;
        },
        handleEdit (index, row) {
            this.formConfig.disabled = false;
            this.editFormVisible = true;
            this.property.config.disabled = false;
            if (row != undefined && row != 'undefined') {
                this.title = '编辑'
                if (index == 2) {
                    this.title = '查看';
                    this.property.config.disabled = true;
                    this.formConfig.disabled = true;
                }
                this.formConfig.dataForm = JSON.parse(JSON.stringify(row));
                this.dialogSelectData.beforeType = row.traineeType;
                this.formConfig.selectTraineeLabel = row.traineeNames.toString()

                if (this.formConfig.dataForm.traineeType === 'dept') {
                    this.$set(this.formConfig.dataForm, 'deptIds', this.formConfig.dataForm.trainee || [])
                } else {
                    this.$set(this.formConfig.dataForm, 'userIds', this.formConfig.dataForm.trainee || [])
                }
                this.changeExamType()
                setTimeout(() => {
                    if (this.$refs.editForm) {
                        this.$refs.editForm.$refs.form.validateField('deptIds');
                        this.$refs.editForm.$refs.form.validateField('userIds');
                    }
                });

                this.$set(this.formConfig.dataForm, 'annexes', row.annexes || [])

            } else {
                this.formConfig.selectTraineeLabel = '';
                this.formConfig.dataForm = {
                    traineeType: 'user',
                    annexes: [],
                    noticeSign: true,
                };
                this.title = '新增'
                if (this.$refs.editForm) {
                    this.$refs.editForm.$refs.form.resetFields();
                }
            }
            this.$forceUpdate()

        },
        changeExamType () {
            this.formConfig.formItems[17].hide = true;
            this.formConfig.formItems[18].hide = true;
            if (this.formConfig.dataForm.traineeType === 'dept') {
                this.$set(this.formConfig.dataForm, 'deptIds', this.formConfig.dataForm.deptIds || [])
                this.formConfig.formItems[18].options = this.commonDept;
                this.formConfig.formItems[18].hide = false;
            } else {
                this.$set(this.formConfig.dataForm, 'userIds', this.formConfig.dataForm.userIds || [])
                this.formConfig.formItems[17].options = this.commonUser;
                this.formConfig.formItems[17].hide = false;
            }
        },
        // 关闭编辑、增加弹出框
        closeDialog () {
            this.$refs.editForm.$refs.form.resetFields();
            this.editFormVisible = false;
            setTimeout(() => {
                this.getData()
            });
        },
        submitForm (editData) {
            let data = JSON.parse(JSON.stringify(this.formConfig.dataForm));
            this.$refs.editForm.$refs.form.validate(async valid => {
                if (valid) {
                    if (data.traineeType === 'dept') {
                        data.trainee = data.deptIds || []
                    } else {
                        data.trainee = data.userIds || []
                    }
                    const res = await (data.offlineTrainPlanId ? offlineEdit(data) : offlineAdd(data));
                    this.$message.success(res.msg);
                    this.closeDialog();
                } else {
                    return false
                }
            })
        },

        async handleAction (index, data) {
            this.offlineTrainPlanId = data.offlineTrainPlanId;
            switch (index) {
                case 4:
                    await offlineRemove([data.offlineTrainPlanId]);
                    this.$message.success('删除成功');
                    this.getData();
                    break;
                case 5:
                    await offlinePublish({ offlineTrainPlanId: data.offlineTrainPlanId });
                    this.$store.state.importLoading = true;
                    const interval = setInterval(async _ => {
                        const res = await offlinePublishStatus(data.offlineTrainPlanId);
                        if (res.data.passSign) {
                            this.$message({
                                message: res.data.successSign ? '发布成功' : '发布失败',
                                type: res.data.successSign ? 'success' : 'warning'
                            });
                            this.$store.state.importLoading = false;
                            await this.getData();
                            clearInterval(interval);
                        }
                    }, 2000);


                    break;
                case 6:
                    this.trainingRecordSheet.materialFileList = [];
                    this.trainingRecordSheet.visible = true;
                    this.trainingRecordSheet.title = '上传培训记录表';
                    break;
                case 7:
                    this.trainingRecordSheet.materialFileList = data.trainResult;
                    this.trainingRecordSheet.visible = true;
                    this.trainingRecordSheet.title = '查看培训记录表';
                    break;
            }
        },
        //  素材文件
        //  封面上传限制
        beforeUpload1 (rawFile, fun) {
            const get = _ => {
                if (!rawFile.name.includes('png') && !rawFile.name.includes('jpg') && !rawFile.name.includes('jpeg') && !rawFile.name.includes('pdf')) {
                    this.$store.state.loading = false;
                    this.$message({ message: '请上传正确的格式！', type: 'error' })
                    return false;
                } else if (rawFile.size / 1024 / 1024 > 20) {
                    this.$store.state.loading = false;
                    this.$message({ message: '超过20MB上传大小！', type: 'error' })
                    return false;
                }
                return true;
            };
            fun(get());
        },
        uploadSuccess (response, file, fileList) {
            this.$store.state.loading = false;
            const data = response.data;
            if (data.fileKey) {
                this.trainingRecordSheet.materialFileList.push({
                    url: data.fileKey,
                    fileKey: data.fileKey,
                    name: data.name,
                    size: data.size,
                    suffix: data.name.split('.')[data.name.split('.').length - 1]
                });
            }
        },
        uploadRemove1 (fileData) {
            const index = this.trainingRecordSheet.materialFileList.findIndex(res => {
                return res.uid === fileData.uid || res.url === fileData.url
            });
            this.trainingRecordSheet.materialFileList.splice(index, 1);
        },
        pdfLoad (e) {
            if (e === 1) {
                this.trainingRecordSheet.fileLoading = false;
            } else this.trainingRecordSheet.fileLoading = true;
        },
        async submitFile () {
            const params = {
                offlineTrainPlanId: this.offlineTrainPlanId,
                trainResult: this.trainingRecordSheet.materialFileList
            }
            const res = await offlineResultUpload(params);
            this.$message.success(res.msg);
            this.trainingRecordSheet.visible = false;
            this.getData();
        },
        async exportExcel () {
            const type = 'vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            downloadFile(await offlineExport({
                ...this.formInline,
            }), type, `线下培训任务-${new Date().getTime()}`);
        },
        showSelectDialog () {
            this.dialogSelectData.visible = true;
            if (this.dialogSelectData.beforeType === this.formConfig.dataForm.traineeType) {
                this.dialogSelectData.selectVal = this.formConfig.dataForm.trainee;
            } else {
                this.dialogSelectData.selectVal = []
            }
            this.dialogSelectData.beforeType = this.formConfig.dataForm.traineeType;
        },
        // 确认选择
        confirmSelect (selectVal, selectTraineeLabel) {
            this.formConfig.selectTraineeLabel = selectTraineeLabel;
            if (this.formConfig.dataForm.traineeType === 'dept') {
                this.$set(this.formConfig.dataForm, 'deptIds', selectVal)
                this.$refs.editForm.$refs.form.validateField('deptIds')
            } else {
                this.$set(this.formConfig.dataForm, 'userIds', selectVal)
                this.$refs.editForm.$refs.form.validateField('userIds')
            }
            this.dialogSelectData.visible = false;

        }
    }
}
</script>

<style lang="scss" scoped>
.user-search {
    margin-top: 20px;
}

.operate {
    margin-right: 10px;
}

.file-right {
    height: 700px;
    overflow: auto;
}
</style>


// WEBPACK FOOTER //
// src/views/offlineTraining/list.vue